import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorCloseOrderCheck = () => {
  const { t } = useTranslation()
  const closeOrderCheck = useCallback(
    (payload, loading, modal) => {
      ApiService.jsonRequest('/transaction-close/check', payload, (response) => {
        if (response.status_code === 200) {
          // show modal close po
          loading(false)
          modal(true)
        } else {
          loading(false)
          showAlert({
            icon: 'warning',
            message: t(`response_message.${response.messages}`),
            timer: 3000,
            reload: false,
          })
        }
      })
    },
    [t],
  )
  return { closeOrderCheck }
}

export default InteractorCloseOrderCheck
